module.exports = __webpack_public_path__ + "static/img/decorate.2eb02ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/decorate.png
// module id = JMyu
// module chunks = 46